import {browserHistory} from 'react-router';
import api from '../../../api';

import createStore from '../../../store/createStore'
import {changeLoading , snackAction} from '../../../routes/Main/modules/main'

export const HOME = 'HOME'
export const DOCTOR_INFO = 'DOCTOR_INFO'
export const DOCTOR_DETAIL  ='DOCTOR_DETAIL'
export const TEXT_CHANGE = 'TEXT_CHANGE'
export const SEARCH = 'SEARCH'
export const PAGINATE = 'PAGINATE'
export const UPDATE_PATIENT_EXAMS = 'UPDATE_PATIENT_EXAMS'
const UPDATE_KEY = 'UPDATE_KEY'
export const OPEN_RESULTPOPUP = 'OPEN_RESULTPOPUP'
const limit = 10;

export function onTextChange(text){
	return (dispatch, getState) => {
		var doctors = {...getState().doctors};
        doctors.searchValue = text;
		dispatch({
			type: TEXT_CHANGE,
			payload: doctors
		})
	}
}

export function onSearch(){
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			var doctors = {...getState().doctors};
            doctors.lockPaginate = false;
			api.get(`/admin/doctors?limit=10&skip=0${doctors.searchValue? `&filter[name]=${doctors.searchValue}`: ''}`)
			.then(response => {
        if (document.querySelector("div[style='height: calc(100vh - 488px); overflow-x: hidden; overflow-y: auto;']")) {
          document.querySelector("div[style='height: calc(100vh - 488px); overflow-x: hidden; overflow-y: auto;']").scrollTop = 0;
        }
                doctors.list = formatDataAfterGet(response.doctors);
				dispatch({
					type: DOCTOR_DETAIL,
					payload: doctors
				});
				resolve(true);
			}, err => {
				// console.log(err);
			})
			resolve();
		})
	}
}

export function onLoad() {
	return (dispatch, getState) => {
		var a = {a:'abc'};
		dispatch({
			type: HOME,
			payload: a
		})
	}
}

export function doctorDetail(id) {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			var doctors = {...getState().doctors};
			dispatch({
				type: DOCTOR_DETAIL,
				payload: doctors
			});
			browserHistory.push('/doctor/' + id);
			resolve();
		});
	}
}

export function getListPatient() {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			api.get(`/admin/doctors?limit=10&skip=0`)
			.then(list => {
				var doctors = {...getState().doctors};
				createStore.dispatch(changeLoading(true));
                doctors.searchValue = "";
                doctors.list = formatDataAfterGet(list.doctors);
				dispatch({
					type: DOCTOR_DETAIL,
					payload: doctors
				});
				resolve(true);
				createStore.dispatch(changeLoading(false));
			}, err => {
				reject(err);
			})
		});
	}
}
const formatDataAfterGet = (list) => {
	return list
}

export const paginate = () => {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			let doctors = {...getState().doctors};
			let query = `?limit=${limit}&skip=${doctors.list.length}${doctors.searchValue? `&filter[name]=${doctors.searchValue}`: ''}`;
            doctors.lockPaginate = true;
            doctors.isLoading = true;
			dispatch({
				type: PAGINATE,
				payload: doctors
			});
			api.get('/admin/doctors' + query, '', true)
			.then(list => {
				let doctors = {...getState().doctors};
                doctors.isLoading = false;
				doctors.list = [...doctors.list,...formatDataAfterGet(list.doctors)];
				doctors.lockPaginate = (list.doctors.length < limit) ? true : false;

				dispatch({
					type: PAGINATE,
					payload: doctors
				});
				resolve()
			})
		});
	}
}

export function clearList() {
	return (dispatch, getState) => {
		return new Promise((resolve, reject) => {
			var doctors = {...getState().doctors};
            doctors.list = [];
			dispatch({
				type: DOCTOR_DETAIL,
				payload: doctors
			});
			resolve(true);
		});
	}
}

export function openPage () {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      createStore.dispatch(changeLoading(true))
      setTimeout(function () {
        Promise.all([api.get(`/admin/doctors?limit=${limit}&skip=0`)])
          .then(result => {
            var doctors = { ...getState().doctors }
            var list = result[0]
            doctors.searchValue = ''
            doctors.list = formatDataAfterGet(list.doctors)
            doctors.lockPaginate = (list.doctors.length < limit)
            dispatch({
              type: DOCTOR_DETAIL,
              payload: doctors
            })
            resolve(true)
            createStore.dispatch(changeLoading(false))
          }, err => {
            reject(err)
          })
      }, 100)
    })
  }
}

const ACTION_HANDLERS = {
	[HOME]: (state, action) => Object.assign({}, state, action.payload),
	[DOCTOR_INFO]: (state, action) => Object.assign({}, state, action.payload),
	[DOCTOR_DETAIL]: (state, action) => Object.assign({}, state, action.payload),
	[TEXT_CHANGE] : (state, action) => Object.assign({}, state, action.payload),
	[SEARCH] : (state, action) => Object.assign({}, state, action.payload),
	[PAGINATE] : (state, action) => Object.assign({}, state, action.payload),
}
const initialState = {
	lockPaginate: false,
	isLoading: false,
	popupResult: false
}

export default function reducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/DoctorDatabase/modules/doctors.js